import { inject, Pipe, PipeTransform } from '@angular/core';
import { StorageType } from '@common/models';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';

@Pipe({
  name: 'accessKeyText',
  pure: true
})
export class AccessKeyTextPipe implements PipeTransform {
  private readonly i18nPipe = inject(I18NextPipe);

  protected readonly moduleAccount = I18_NAMESPACE_APPS_UI.account;

  transform(type: StorageType, mode: 'label' | 'placeholder'): string {
    switch (type) {
      case StorageType.AzureStack:
      case StorageType.Azure:
        return mode === 'label'
          ? this.i18nPipe.transform(this.moduleAccount + ':sidepanel.label.storageAccountName', { format: 'capitalize' })
          : this.i18nPipe.transform(this.moduleAccount + ':sidepanel.placeholder.storageAccountName', { format: 'capitalize' });
      case StorageType.BackBlaze:
        return mode === 'label'
          ? this.i18nPipe.transform(this.moduleAccount + ':sidepanel.label.accountID', { format: 'capitalize' })
          : this.i18nPipe.transform(this.moduleAccount + ':sidepanel.placeholder.accountID', { format: 'capitalize' });
      default:
        return mode === 'label'
          ? this.i18nPipe.transform(this.moduleAccount + ':sidepanel.label.accessKey', { format: 'capitalize' })
          : this.i18nPipe.transform(this.moduleAccount + ':sidepanel.placeholder.accessKey', { format: 'capitalize' });
    }
  }
}
